// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// #####################################################################################
//   TO RUN THE EXTENSION LOCALLY, CHANGE THE KEY IN manifest.emea.json TO THE FOLLOWING:  ##
//     tslint:disable-next-line:max-line-length                                       ##
//   "key": "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAm7JSVMP6Rn4zrA7zfdrmHdjlWHQ4R  x8F/opbQq5tuFeFXZUJWBta6F/frpbmNCXEBuE/gnHsdlLQFYRZVuWgVyUSII3yK0IPrluidVLoHhuAScF8BN972ZCnYjaXypAvw15Qc39wse09YbMklCchXyBxF/tDRiLfSnTuMjFOOzNDceI9I/qXMytqdNRY5A9pZcmaa542VtVqYty40m/arQ8DBWA1ZeKOXPlLNW52QvxgEHPCrwh1oPnAhaaNZo9/h7zBOnS7ccNcvsxrUtdt4kKRlenbSDCteb3jFAd71NExIugZF5kkCUV6CoZ+VHLWe/SvQV/tUKhGlW2E+JGUQwIDAQAB",
// #####################################################################################
import { IEnvironment, IRuntimeEnvironment } from 'interfaces-lib';
import { StorageType } from 'storage-service-lib';
import { buildVersion } from './build.version';

export const environment: Partial<IEnvironment> = {
  appName: 'awesomedocs-v2-document-client',
  name: 'dev',
  featureFlagsUrl: 'https://platform-dev.kyloe.io/feature-flags/api/v1/client-init',
  featureFlagsApiKey: 'Kv5tiKDe4i8O7jFYZz5wNawc3d3hqJ8L7KlKXTRa',
  identityStorageType: StorageType.SESSION,
  kpHost: 'https://backend-dev.awesome-docs.io',
  kpWorkflowHost: 'https://backend-dev.awesome-docs.io',
  kpWorkflowStatus: 'wss://backend-dev.awesome-docs.io',
  adApiGatewayUrl: 'https://api-datatoolsadmin.kyloe.plus/qa-internal',
  adApiGatewayKey: 'PbFTLDLVTF1JateBwg0TG4KxU7hZvzJKzzykQqQh',

  uiHost: 'https://ad-ui-dev.awesome-docs.io',
  chromeUiHost: 'chrome-extension://amilcmpcjeppipfjfdnfhfclnakfdchd',

  production: false,
  version: buildVersion + '-DEV',

  enableAnalytics: false,

  // AWS RUM Config
  awsRum: {
    endpoint: 'https://dataplane.rum.eu-west-1.amazonaws.com',
    guestRoleArnWebApp: 'arn:aws:iam::393399738482:role/RUM-Monitor-eu-west-1-393399738482-9904864767761-Unauth',
    identityPoolIdWebApp: 'eu-west-1:f49722e8-85a2-4b9c-8cf1-ae27a576a158',
    APPLICATION_IDWebApp: '0fc6b6c7-164f-4ce9-ad4e-ca56f49eb858',
    guestRoleArnChromeExt: 'arn:aws:iam::393399738482:role/RUM-Monitor-eu-west-1-393399738482-9697574767761-Unauth',
    identityPoolIdChromeExt: 'eu-west-1:28583ac6-810e-411e-bfff-df850c0500ab',
    APPLICATION_IDChromeExt: 'c076569a-20b0-4d4f-92b9-9f70660297bf',
    APPLICATION_REGION: 'eu-west-1',
  },

  // Google Analytics Config
  googleAnalyticsWebApp: '',
  googleAnalyticsChromeExt: '',

  // Pendo
  pendoWebAppAPIKey: '11e785ad-8efd-4b42-63a2-015eb68122b6',
  pendoChromeExtAPIKey: '6df9da6f-9452-412b-44c2-fc2e6344b890',
};

export const runtimeEnvironment: IRuntimeEnvironment = {
  client: { name: undefined, clientId: undefined, redirectUrl: undefined }, // e.g names: kyloedev or amos-s3 or 9648
  origin: { url: undefined, namespace: undefined }, // e.g. https://kyloedev.invenias.com, invenias or invenias-mock or bullhorn
  runningAsChromeExtension: false,
  renderMode: 'web-app',
  jwt: undefined, // TODO: move this?
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
